import {Dce, DceComponent, DceHTMLElement} from "dce-engine";
import {DceAjax} from "dce-ajax";
import {FragmentsContext} from "../index";

export interface LazyFragmentProps {
    //klasa po stronie serwera
    name: string,
    //propertiesy z serwera
    props: string,
}

@Dce("LazyFragment")
export default class LazyFragment extends DceComponent<LazyFragmentProps> {
    private loadingElement: Array<[HTMLElement, string]> = [];

    constructor(elem: DceHTMLElement, props: LazyFragmentProps) {
        super(elem, props);

        this.load();

    }

    public async load() {

        console.log("LOADING...");
        this.findLoadingElement();
        this.showLoading();

        let response = await DceAjax.getInstance().get(
            "/" + FragmentsContext.route() + "/wire/load/" + encodeURIComponent(this.props.name) + "/" + encodeURIComponent(this.props.props)
        );

        setTimeout(() => {

            let tmp;
            if (response.isValid()) {
                let v = response.data.html;

                tmp = document.createElement('div');
                tmp.innerHTML = v;

                this.elem.replaceWith(tmp.firstElementChild);
            }

        });
    }


    private findLoadingElement() {
        let foundElements = this.elem.querySelectorAll('*[data-wire-loading]');

        if (foundElements.length > 0) {
            this.loadingElement = new Array<[HTMLElement, string]>();
            foundElements.forEach(e => {
                let display = e.getAttribute('data-wire-loading');
                this.loadingElement.push(
                    [e as HTMLElement, display]
                );
            });
        }
    }

    private showLoading() {
        console.log("SHOW LOADING");

        this.loadingElement.forEach((d, index) => {
            d[0].style.display = d[1];
        });
        return;

    }

}
